module.exports = __webpack_public_path__ + "static/media/co05.d3fdd29c.png";